import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M12 16v.01","key":"svg-0"}],["path",{"d":"M12 13a2 2 0 0 0 .914 -3.782a1.98 1.98 0 0 0 -2.414 .483","key":"svg-1"}]]

/**
 * IconHelpSmall
 * @preview ![img](data:image/svg+xml;base64,PHN2ZwogIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIKICB3aWR0aD0iMjQiCiAgaGVpZ2h0PSIyNCIKICB2aWV3Qm94PSIwIDAgMjQgMjQiCiAgZmlsbD0ibm9uZSIKICBzdHJva2U9ImN1cnJlbnRDb2xvciIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCiAgY2xhc3M9Imljb24gaWNvbi10YWJsZXIgaWNvbnMtdGFibGVyLW91dGxpbmUgaWNvbi10YWJsZXItaGVscC1zbWFsbCIKPgogIDxwYXRoIHN0cm9rZT0ibm9uZSIgZD0iTTAgMGgyNHYyNEgweiIgZmlsbD0ibm9uZSIgLz4KICA8cGF0aCBkPSJNMTIgMTZ2LjAxIiAvPgogIDxwYXRoIGQ9Ik0xMiAxM2EyIDIgMCAwIDAgLjkxNCAtMy43ODJhMS45OCAxLjk4IDAgMCAwIC0yLjQxNCAuNDgzIiAvPgo8L3N2Zz4=) - https://tabler.io/icons/icon/help-small
 * @see https://docs.tabler.io/icons/libraries/react - Documentation
 *
 */
const IconHelpSmall = createReactComponent('outline', 'help-small', 'HelpSmall', __iconNode);

export default IconHelpSmall;